const developmentApiUrl = "http://localhost:4000";

export const resolveApiBaseUrl = (
  configuredUrl = import.meta.env.VITE_API_URL,
) => {
  return (configuredUrl || developmentApiUrl).replace(/\/+$/, "");
};

export const API_BASE_URL = resolveApiBaseUrl();

export const CLIENT_API_BASE_URL = resolveApiBaseUrl(
  import.meta.env.VITE_CLIENT_API_URL || "http://localhost:4100",
);

export const resolveApiRequestUrl = (requestUrl, baseUrl = API_BASE_URL) => {
  const normalizedBaseUrl = resolveApiBaseUrl(baseUrl);
  const normalizedRequestUrl = requestUrl.startsWith("/")
    ? requestUrl
    : `/${requestUrl}`;

  // Compatibilidad con instalaciones antiguas cuya base ya terminaba en /api.
  if (
    normalizedBaseUrl.endsWith("/api") &&
    normalizedRequestUrl.startsWith("/api/")
  ) {
    return `${normalizedBaseUrl}${normalizedRequestUrl.substring(4)}`;
  }

  return `${normalizedBaseUrl}${normalizedRequestUrl}`;
};
